<template>
    <div>
        <transition name="bounce">
            <div class="col-md-12" v-if="content.isItOk">
                <div class="float-right abtg__saveMode">Salvato!</div>
            </div>
        </transition>
    </div>
</template>
<script>

    import {createHelpers} from 'vuex-map-fields';

    const {mapFields} = createHelpers({
        getterType: 'tvalutation/getField',
        mutationType: 'tvalutation/updateField',
    });

    export default {
        props: ['content'],
        components: {},
        data: function () {
            return {}
        },

        computed: {
            ...mapFields([]),
        },
        created: function () {
        },
        methods: {}
    }
</script>